import { useRef, useState } from "react";

/**
 * @returns {[React.MutableRefObject<any>, ((newState: any) => void)]}
 */
export default function useStateWithRef(defaultState) {
  const [state, _setState] = useState(defaultState);
  const stateRef = useRef(state);

  const setState = (newState) => {
    stateRef.current = newState;
    _setState(newState);
  };
  return [stateRef, setState];
}
